export default __webpack_public_path__ + "static/media/ic_room_primary.99a50c13.svg";